/**
 * Triumph Quick Buy
 * Opens a modal with product images, color & size selectors, and ATC.
 */
(function () {
  'use strict';

  const modal    = document.getElementById('quickBuyModal');
  if (!modal) return;

  const closeBtn = modal.querySelector('.js-qbClose');
  const backBtn   = modal.querySelector('.js-qbBack');
  const mainImg  = modal.querySelector('#qbMainImage');
  const prevBtn   = modal.querySelector('.js-qbPrev');
  const nextBtn   = modal.querySelector('.js-qbNext');
  const dotsEl    = modal.querySelector('.js-qbDots');
  const thumbsEl  = modal.querySelector('.js-qbThumbs');
  const nameEl   = modal.querySelector('.js-qbName');
  const subtitleEl = modal.querySelector('.js-qbSubtitle');
  const priceEl  = modal.querySelector('.js-qbPrice');
  const rrpEl    = modal.querySelector('.js-qbRrp');
  const colorSec = modal.querySelector('.js-qbColorSection');
  const colorNameEl = modal.querySelector('.js-qbColorName');
  const swatchesEl  = modal.querySelector('.js-qbSwatches');
  const sizeSec    = modal.querySelector('.js-qbSizeSection');
  const selectedSizeLabel = modal.querySelector('.js-qbSelectedSize');
  const simpleWrap  = modal.querySelector('.js-qbSizesSimple');
  const braWrap    = modal.querySelector('.js-qbSizesBra');
  const simpleRow  = modal.querySelector('.js-qbSizeRow--simple');
  const bandRow    = modal.querySelector('.js-qbSizeRow--band');
  const cupRow     = modal.querySelector('.js-qbSizeRow--cup');
  const feedbackEl = modal.querySelector('.js-qbFeedback');
  const atcBtn     = modal.querySelector('.js-qbAtc');
  const detailsLink = modal.querySelector('.js-qbDetailsLink');

  let sliderImgs  = [];
  let sliderIndex = 0;
  let sourceModal  = null; // tracks which modal opened the quickbuy
  let swatchContext = null; // preserves ordered swatch list across related-product loads

  function goToSlide(i) {
    sliderIndex = (i + sliderImgs.length) % sliderImgs.length;
    setMainImage(sliderImgs[sliderIndex]);
    // sync dots
    dotsEl.querySelectorAll('.qb-dot').forEach((d, idx) => d.classList.toggle('qb-dot--active', idx === sliderIndex));
    // sync thumbs
    thumbsEl.querySelectorAll('.qb-thumb').forEach((t, idx) => t.classList.toggle('qb-thumb--active', idx === sliderIndex));
    prevBtn.style.display = sliderImgs.length > 1 ? '' : 'none';
    nextBtn.style.display = sliderImgs.length > 1 ? '' : 'none';
  }

  prevBtn.addEventListener('click', () => goToSlide(sliderIndex - 1));
  nextBtn.addEventListener('click', () => goToSlide(sliderIndex + 1));

  // Swipe support
  let touchStartX = 0;
  mainImg.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
  mainImg.addEventListener('touchend', e => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) goToSlide(sliderIndex + (diff > 0 ? 1 : -1));
  });

  let product       = null;
  let selectedVariantId = null;
  let selectedColor = null;
  let selectedBand  = null;
  let selectedCup   = null;
  let selectedSize  = null;  // for non-bra simple sizes
  let isBraProduct  = false;

  /* ─── helpers ─────────────────────────────────────────────── */

  function formatMoney(cents) {
    return window.Shopify && window.Shopify.currency
      ? (cents / 100).toFixed(2) + ' ' + Shopify.currency.active
      : '£' + (cents / 100).toFixed(2);
  }

  function normalizeOptionName(n) {
    return (n || '').toLowerCase().replace(/[_\s]+/g, ' ').trim();
  }

  function getOptionIndex(product, name) {
    const needle = normalizeOptionName(name);
    return product.options.findIndex(
      o => normalizeOptionName(o.name || o) === needle
    );
  }

  function findVariant(product, color, band, cup, size) {
    return product.variants.find(v => {
      const opts = [v.option1, v.option2, v.option3].filter(Boolean);
      if (isBraProduct) {
        const match = opts.includes(color) && opts.includes(band) && opts.includes(cup);
        return match;
      } else {
        const matchC = color ? opts.includes(color) : true;
        const matchS = size  ? opts.includes(size)  : true;
        return matchC && matchS;
      }
    });
  }

  function shopifyImgSize(src, size) {
    if (!src) return src;
    // Shopify size transform only works on /products/ CDN paths, not /files/
    if (src.includes('/files/')) return src;
    // Strip any existing Shopify size suffix (_600x, _600x800, etc.)
    let clean = src.replace(/_\d+x\d*(?=\.(?:jpg|jpeg|png|gif|webp))/i, '');
    // Insert new size before extension, preserve query string
    return clean.replace(/(\.(?:jpg|jpeg|png|gif|webp))(\?[^"]*)?$/i, (_, ext, qs) => '_' + size + ext + (qs || ''));
  }

  function setMainImage(url, alt) {
    mainImg.src = url;
    mainImg.alt = alt || '';
  }

  function setThumbActive(index) {
    thumbsEl.querySelectorAll('.qb-thumb').forEach((t, i) => {
      t.classList.toggle('qb-thumb--active', i === index);
    });
  }

  /* ─── render ──────────────────────────────────────────────── */

  function renderModal(prod) {
    product = prod;

    // Name / subtitle
    nameEl.textContent     = prod.title.toUpperCase();
    subtitleEl.textContent = prod.type || '';
    if (detailsLink) detailsLink.href = '/products/' + prod.handle;

    // Images — combine prod.images + all variant featured_images (deduped)
    // Shopify /products/handle.js returns images as plain URL strings; normalise to objects
    const normalizeImg = img => (img && typeof img === 'string') ? { src: img } : img;
    const seen = new Set();
    const allImages = [];
    [...prod.images.map(normalizeImg), ...prod.variants.map(v => v.featured_image)].forEach(img => {
      if (img && img.src && !seen.has(img.src)) {
        seen.add(img.src);
        allImages.push(img);
      }
    });
    // Build thumbnails
    thumbsEl.innerHTML = '';
    const imgs = allImages.slice(0, 8);
    imgs.forEach((img, i) => {
      const thumbUrl = img.src;
      const btn = document.createElement('button');
      btn.className = 'qb-thumb' + (i === 0 ? ' qb-thumb--active' : '');
      btn.dataset.index = i;
      btn.innerHTML = `<img src="${thumbUrl}" alt="" loading="lazy" />`;
      btn.addEventListener('click', () => goToSlide(i));
      thumbsEl.appendChild(btn);
    });
    // Show/hide thumb strip
    thumbsEl.classList.toggle('qb-thumbs--hidden', imgs.length <= 1);

    // Build slider
    sliderImgs = allImages.map(img => img.src);
    sliderIndex = 0;
    dotsEl.innerHTML = '';
    sliderImgs.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'qb-dot' + (i === 0 ? ' qb-dot--active' : '');
      dot.addEventListener('click', () => goToSlide(i));
      dotsEl.appendChild(dot);
    });
    prevBtn.style.display = sliderImgs.length > 1 ? '' : 'none';
    nextBtn.style.display = sliderImgs.length > 1 ? '' : 'none';
    dotsEl.style.display  = sliderImgs.length > 1 ? '' : 'none';
    if (imgs.length && imgs[0].src) {
      const first = shopifyImgSize(imgs[0].src, '800x');
      setMainImage(first, prod.title);
    }

    // Price (use first variant as default)
    updatePrice(prod.variants[0]);

    // Detect bra sizing by name OR by option values
    // Band: option whose values are mostly numbers (28,30,32..50)
    // Cup:  option whose values are mostly letters (A,B,C,D,DD,E,F,G)
    let bandIdx = getOptionIndex(prod, 'band size');
    let cupIdx  = getOptionIndex(prod, 'cup size');
    const colorIdx = getOptionIndex(prod, 'color');

    if (bandIdx < 0 || cupIdx < 0) {
      // fallback: detect by values
      prod.options.forEach((opt, i) => {
        const vals = (opt.values || []).map(v => String(v).trim());
        // Band: all numeric AND in typical bra band range 28–50
        const isBandLike = vals.length > 0 && vals.every(v => /^\d+$/.test(v) && +v >= 28 && +v <= 50);
        // Cup: all letter combinations A–G (single or double like DD, FF)
        const isCupLike  = vals.length > 0 && vals.every(v => /^[A-G]{1,2}$/i.test(v));
        if (isBandLike && bandIdx < 0) bandIdx = i;
        if (isCupLike  && cupIdx  < 0) cupIdx  = i;
      });
    }

    isBraProduct = bandIdx >= 0 && cupIdx >= 0;
    console.log('[QuickBuy] options:', prod.options.map(o => o.name || o), '| isBra:', isBraProduct, '| bandIdx:', bandIdx, '| cupIdx:', cupIdx);

    // Colour swatches
    if (colorIdx >= 0) {
      const colors = [...new Set(prod.variants.map(v => v['option' + (colorIdx + 1)]).filter(Boolean))];
      swatchesEl.innerHTML = '';
      colors.forEach(color => {
        // Find the first variant for this colour, use its featured_image as swatch
        // Fall back to the first product image if the variant has no assigned image
        const variant = prod.variants.find(v => [v.option1, v.option2, v.option3].includes(color));
        const rawSrc = (variant && variant.featured_image && variant.featured_image.src)
          ? variant.featured_image.src
          : (prod.images.length ? (typeof prod.images[0] === 'string' ? prod.images[0] : prod.images[0].src) : null);
        const swatchSrc = rawSrc ? shopifyImgSize(rawSrc, '150x150') : null;

        const btn = document.createElement('button');
        btn.className = 'qb-swatch';
        btn.dataset.color = color;
        btn.title = color;
        if (swatchSrc) {
          btn.innerHTML = `<img src="${swatchSrc}" alt="${color}" width="60" height="60" style="object-fit:cover;width:60px;height:60px;display:block;" />`;
        } else {
          btn.textContent = color.charAt(0);
        }
        btn.addEventListener('click', () => selectColor(color));
        swatchesEl.appendChild(btn);
      });
      colorSec.hidden = false;
      // Auto-select first color
      if (colors.length > 0) selectColor(colors[0], false);
    } else {
      colorSec.hidden = true;
      selectedColor = null;
    }

    // Reset size state BEFORE rendering sizes so auto-select works fresh
    selectedBand = null;
    selectedCup  = null;
    selectedSize = null;
    selectedVariantId = null;
    if (selectedSizeLabel) selectedSizeLabel.textContent = '';

    // Sizes
    if (isBraProduct) {
      renderBraSizes();
      braWrap.hidden  = false;
      simpleWrap.hidden = true;
    } else {
      renderSimpleSizes(colorIdx);
      simpleWrap.hidden = false;
      braWrap.hidden  = true;
    }
    sizeSec.hidden = false;

    feedbackEl.hidden = true;
    feedbackEl.textContent = '';
    // Note: atcBtn text/disabled state is already set correctly by selectSize()
    // called inside renderBraSizes() / renderSimpleSizes() above — do NOT override here.
  }

  function selectColor(color, updateSizes = true) {
    selectedColor = color;
    colorNameEl.textContent = color;
    // highlight active swatch
    swatchesEl.querySelectorAll('.qb-swatch').forEach(s => {
      s.classList.toggle('qb-swatch--active', s.dataset.color === color);
    });
    // update main image to color's featured image
    const variant = product.variants.find(v => [v.option1, v.option2, v.option3].includes(color));
    const colorImg = variant && variant.featured_image && variant.featured_image.src ? variant.featured_image : null;
    if (colorImg) {
      const url = shopifyImgSize(colorImg.src, '800x');
      setMainImage(url, color);
      // jump slider to matching image
      const idx = sliderImgs.findIndex(s => s === colorImg.src);
      if (idx >= 0) goToSlide(idx);
    }
    if (updateSizes) {
      if (isBraProduct) {
        selectedBand = null;
        selectedCup  = null;
        renderBraSizes();
      } else {
        selectedSize = null;
        const colorIdx = getOptionIndex(product, 'color');
        renderSimpleSizes(colorIdx);
      }
      selectedVariantId = null;
      atcBtn.disabled = true;
    }
  }

  function getEffectiveOptionIndex(prod, nameHint) {
    let idx = getOptionIndex(prod, nameHint);
    if (idx >= 0) return idx;
    // fallback by value shape
    prod.options.forEach((opt, i) => {
      const vals = (opt.values || []).map(v => String(v).trim());
      if (nameHint === 'band size' && vals.length > 0 && vals.every(v => /^\d+$/.test(v))) idx = i;
      if (nameHint === 'cup size'  && vals.length > 0 && vals.every(v => /^[A-G]{1,2}$/i.test(v))) idx = i;
    });
    return idx;
  }

  function renderBraSizes() {
    const bandIdx  = getEffectiveOptionIndex(product, 'band size');
    const cupIdx   = getEffectiveOptionIndex(product, 'cup size');
    const colorIdx = getOptionIndex(product, 'color');

    // Filter variants by current color
    const relevant = product.variants.filter(v => {
      if (colorIdx < 0 || !selectedColor) return true;
      return v['option' + (colorIdx + 1)] === selectedColor;
    });

    const bands = [...new Set(relevant.map(v => v['option' + (bandIdx + 1)]))].sort((a, b) => parseFloat(a) - parseFloat(b));
    const cups  = [...new Set(relevant.map(v => v['option' + (cupIdx  + 1)]))].sort();

    renderSizeButtons(bandRow, bands, 'band');
    renderSizeButtons(cupRow,  cups,  'cup');

    // Auto-select the first variant's band and cup (both lists are sorted, so
    // index 0 is not necessarily the product's default)
    if (bands.length > 0) selectSize(relevant[0]['option' + (bandIdx + 1)], 'band');
    if (cups.length  > 0) selectSize(relevant[0]['option' + (cupIdx + 1)], 'cup');
  }

  // Wearing-order rank for clothing sizes. Keep in sync with
  // snippets/size-sort-key.liquid.
  const LETTER_RANKS = { XXS: 10, XS: 20, S: 30, M: 40, L: 50, XL: 60, XXL: 70, '2XL': 70,
    XXXL: 80, '3XL': 80, '4XL': 90, '5XL': 100, '6XL': 110, '7XL': 120, '8XL': 130, '9XL': 140 };
  function sizeRank(value) {
    let base = String(value).trim().toUpperCase();
    let modifier = 0;
    if (base.includes('-')) { base = base.split('-')[0]; modifier = 5; }
    if (base.endsWith('+')) {
      base = base.slice(0, -1); modifier += 1;
    } else if (base.length > 1 && base.endsWith('2') && LETTER_RANKS[base.slice(0, -1)] !== undefined) {
      base = base.slice(0, -1); modifier += 2;
    }
    if (LETTER_RANKS[base] !== undefined) return LETTER_RANKS[base] * 10 + modifier;
    if (/^\d+(\.\d+)?$/.test(base)) return Number(base) * 10 + modifier;
    return Infinity;
  }
  function sortSizes(values) {
    // Array.prototype.sort is stable, so unknown sizes keep their order
    return [...values].sort((a, b) => {
      const ra = sizeRank(a), rb = sizeRank(b);
      return ra === rb ? 0 : (ra < rb ? -1 : 1);
    });
  }

  function renderSimpleSizes(colorIdx) {
    const sizeIdx = product.options.findIndex(o => !['color'].includes(normalizeOptionName(o.name || o)));
    if (sizeIdx < 0) { sizeSec.hidden = true; return; }

    const relevant = product.variants.filter(v => {
      if (colorIdx < 0 || !selectedColor) return true;
      return v['option' + (colorIdx + 1)] === selectedColor;
    });

    const sizes = sortSizes(new Set(relevant.map(v => v['option' + (sizeIdx + 1)])));
    renderSizeButtons(simpleRow, sizes, 'simple');

    // Auto-select the first variant's size (the list is sorted, so index 0 is
    // not necessarily the product's default)
    if (sizes.length > 0) selectSize(relevant[0]['option' + (sizeIdx + 1)], 'simple');
  }

  function renderSizeButtons(container, values, type) {
    container.innerHTML = '';
    values.forEach(val => {
      if (!val) return;
      const btn = document.createElement('button');
      btn.className = 'qb-size-btn';
      btn.dataset.size = val;
      btn.dataset.sizeType = type;
      btn.textContent = val;
      btn.addEventListener('click', () => selectSize(val, type));
      container.appendChild(btn);
    });
  }

  function selectSize(val, type) {
    if (type === 'band') {
      selectedBand = val;
      bandRow.querySelectorAll('.qb-size-btn').forEach(b => b.classList.toggle('qb-size-btn--active', b.dataset.size === val));
    } else if (type === 'cup') {
      selectedCup = val;
      cupRow.querySelectorAll('.qb-size-btn').forEach(b => b.classList.toggle('qb-size-btn--active', b.dataset.size === val));
    } else {
      selectedSize = val;
      simpleRow.querySelectorAll('.qb-size-btn').forEach(b => b.classList.toggle('qb-size-btn--active', b.dataset.size === val));
    }

    // Update selected size label
    if (selectedSizeLabel) {
      if (isBraProduct && selectedBand && selectedCup) {
        selectedSizeLabel.textContent = selectedBand + selectedCup;
      } else if (!isBraProduct && selectedSize) {
        selectedSizeLabel.textContent = selectedSize;
      }
    }

    const variant = findVariant(product, selectedColor, selectedBand, selectedCup, selectedSize);
    if (variant) {
      selectedVariantId = variant.id;
      updatePrice(variant);
      if (variant.available) {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Shopping Bag';
        atcBtn.classList.remove('qb-atc--oos');
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Out of Stock';
        atcBtn.classList.add('qb-atc--oos');
      }
    } else {
      selectedVariantId = null;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Out of Stock';
      atcBtn.classList.add('qb-atc--oos');
    }
  }

  function updatePrice(variant) {
    if (!variant) return;
    priceEl.textContent = formatMoney(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      rrpEl.textContent = 'RRP ' + formatMoney(variant.compare_at_price);
      rrpEl.hidden = false;
    } else {
      rrpEl.hidden = true;
    }
  }

  /* ─── open / close ────────────────────────────────────────── */

  /* ─── standalone pre-loader (shows before modal opens) ─── */
  let qbLoader = document.getElementById('qb-pre-loader');
  if (!qbLoader) {
    qbLoader = document.createElement('div');
    qbLoader.id = 'qb-pre-loader';
    qbLoader.className = 'qb-modal-loader is-hidden';
    const isSloggi = document.body.classList.contains('isSloggi');
    const logoHtml = isSloggi && window.sloggiLogoUrl
      ? `<img class="qb-modal-loader__logo-img" src="${window.sloggiLogoUrl}" alt="sloggi" />`
      : '<span class="qb-modal-loader__logo">Triumph</span>';
    qbLoader.innerHTML = logoHtml + '<span class="qb-modal-loader__spinner"></span>';
    document.body.appendChild(qbLoader);
  }

  function showModalLoader() { qbLoader.classList.remove('is-hidden'); }
  function hideModalLoader() { qbLoader.classList.add('is-hidden'); }

  function openModal() {
    modal.hidden = false;
    document.body.classList.add('qb-open');
    setTimeout(() => modal.classList.add('qb-overlay--visible'), 10);
    if (backBtn) backBtn.hidden = !sourceModal;
  }

  function closeModal() {
    modal.classList.remove('qb-overlay--visible');
    setTimeout(() => {
      modal.hidden = true;
      document.body.classList.remove('qb-open');
      refreshLazyImages();
    }, 250);
    sourceModal = null;
    swatchContext = null;
    if (backBtn) backBtn.hidden = true;
  }

  function refreshLazyImages() {
    // Manually load any js-lazy images that are now in the viewport
    document.querySelectorAll('img.js-lazy[data-src]').forEach(img => {
      const tile = img.closest('.productTile');
      const rect = tile ? tile.getBoundingClientRect() : img.getBoundingClientRect();
      if (rect.top < window.innerHeight + 600 && rect.bottom > -600) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.classList.remove('js-lazy');
        // Also swap data-srcset on sibling <source> elements if present
        const picture = img.closest('picture');
        if (picture) {
          picture.querySelectorAll('source[data-srcset]').forEach(src => {
            src.srcset = src.dataset.srcset;
            src.removeAttribute('data-srcset');
          });
        }
      }
    });
    // Re-fire scroll/resize so any IntersectionObserver / scroll-based loader picks up
    window.dispatchEvent(new Event('scroll'));
    window.dispatchEvent(new Event('resize'));
  }

  closeBtn.addEventListener('click', closeModal);
  if (backBtn) backBtn.addEventListener('click', () => {
    // Close quickbuy and reopen the makeTheLook modal
    const returnTo = sourceModal;
    closeModal();
    if (returnTo) {
      setTimeout(() => {
        returnTo.style.display = 'flex';
        returnTo.classList.add('show');
      }, 260);
    }
  });
  modal.addEventListener('click', e => { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });

  /* ─── add to cart ─────────────────────────────────────────── */

  atcBtn.addEventListener('click', async () => {
    if (!selectedVariantId) {
      showFeedback('Please select a size.', false);
      return;
    }
    atcBtn.disabled = true;
    atcBtn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: selectedVariantId, quantity: 1 }),
      });
      if (!res.ok) throw new Error('Cart error');

      // Let the free gift be added before the flyout renders the cart
      if (window.triumphGwpSync) await window.triumphGwpSync();

      // Fetch full cart to render flyout
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      atcBtn.textContent = 'Added ✓';
      atcBtn.classList.remove('qb-atc--oos');

      // Close quick-buy modal
      closeModal();

      // Update badge
      updateCartBadge();

      // Open Triumph cart flyout
      openTriumphCartFlyout(cart, selectedVariantId);

      setTimeout(() => {
        atcBtn.textContent = 'Add to Shopping Bag';
        atcBtn.disabled = false;
      }, 600);
    } catch (e) {
      atcBtn.textContent = 'Add to Shopping Bag';
      atcBtn.disabled = false;
      showFeedback('Something went wrong. Please try again.', false);
    }
  });

  function openTriumphCartFlyout(cart, justAddedVariantId) {
    const flyout = document.getElementById('triumphCartFlyout');
    if (!flyout) return;

    const itemsEl  = flyout.querySelector('#tcf-items');
    const totalsEl = flyout.querySelector('#tcf-totals');
    const currency = window.Shopify && Shopify.currency ? Shopify.currency.active : '';

    // Open flyout immediately
    flyout.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    if (justAddedVariantId) {
      clearTimeout(flyout._autoCloseTimer);
      flyout._autoCloseTimer = setTimeout(function () {
        flyout.classList.remove('is-open');
        document.body.style.overflow = '';
      }, 5000);
    }

    // Render immediately — no waiting for product fetches
    const productMap = {};
    try {
      _renderFlyoutContents(cart, justAddedVariantId, flyout, itemsEl, totalsEl, currency, productMap);
    } catch(e) {
      if (itemsEl) itemsEl.innerHTML = '<div style="padding:16px;color:#999;">Could not load cart. Please refresh.</div>';
    }

    // Silently fetch real option names in background and re-render labels only
    const handles = [...new Set(cart.items.map(i => i.handle))].filter(Boolean);
    if (handles.length) {
      Promise.all(handles.map(h =>
        fetch('/products/' + h + '.js')
          .then(r => r.ok ? r.json() : null)
          .then(p => { if (p) productMap[h] = p.options; })
          .catch(() => {})
      )).then(() => {
        flyout.querySelectorAll('.tcf-item__select-label').forEach(function(label) {
          var row = label.closest('.tcf-item__select-row');
          if (!row) return;
          var sel = row.querySelector('.tcf-item__select');
          if (!sel || sel.classList.contains('js-tcfQty')) return;
          var item = cart.items.find(function(i) { return i.key === (sel.dataset.key); });
          if (!item || !productMap[item.handle]) return;
          var type = sel.dataset.type;
          var opts = productMap[item.handle].map(function(o) { return o.name; });
          if (type === 'colour' && opts[0]) label.textContent = opts[0] + ':';
          else if (type === 'size' && opts[1]) label.textContent = opts[1] + ':';
        });
      });
    }
  }

  function _selectRow(label, value, type, key) {
    return '<div class="tcf-item__select-row">' +
      '<label class="tcf-item__select-label">' + label + ':</label>' +
      '<div class="tcf-item__select-wrap">' +
      '<select class="tcf-item__select" data-key="' + key + '" data-type="' + type + '">' +
      '<option selected>' + value + '</option>' +
      '</select>' +
      '<span class="tcf-item__select-chevron">&#8964;</span>' +
      '</div></div>';
  }

  function _renderFlyoutContents(cart, justAddedVariantId, flyout, itemsEl, totalsEl, currency, productMap) {
    // Reset footer: clears both totals and any previous "complete the set"
    var footerEl = flyout.querySelector('.triumph-cart-flyout__footer');
    if (footerEl) footerEl.innerHTML = '<div id="tcf-totals" class="triumph-cart-flyout__totals"></div>';
    var totalsEl = flyout.querySelector('#tcf-totals');

    const sorted = [...cart.items].sort((a, b) =>
      a.variant_id === justAddedVariantId ? -1 : b.variant_id === justAddedVariantId ? 1 : 0
    );

    itemsEl.innerHTML = sorted.map(function(item) {
      var imgSrc = item.image ? item.image.replace(/(\.(jpg|jpeg|png|gif|webp))/i, '_200x$1') : '';
      var price  = (item.final_price / 100).toFixed(2);
      // Free gift managed by gift-with-purchase.js: shown without quantity or remove controls
      var giftLabel = item.properties && item.properties._gwp;

      // Option names from fetched product, fallback positional
      var optNames  = (productMap[item.handle] || []).map(function(o) { return o.name; });
      var optValues = item.variant_options || (item.variant_title || '').split(' / ');

      var dropdownsHtml = '';
      if (optValues.length > 0 && item.variant_title && item.variant_title !== 'Default Title') {
        if (optValues.length >= 3) {
          // e.g. [CHERRY ROSE, 34, C] → Colour + combined Size (34C)
          dropdownsHtml += _selectRow(optNames[0] || 'Colour', optValues[0], 'colour', item.key);
          dropdownsHtml += _selectRow('Size', optValues[1] + optValues[2], 'size', item.key);
        } else if (optValues.length === 2) {
          dropdownsHtml += _selectRow(optNames[0] || 'Colour', optValues[0], 'colour', item.key);
          dropdownsHtml += _selectRow(optNames[1] || 'Size', optValues[1], 'size', item.key);
        } else {
          dropdownsHtml += _selectRow(optNames[0] || 'Size', optValues[0], 'size', item.key);
        }
      }

      // Quantity dropdown (functional)
      if (!giftLabel) {
        var qtyOptions = '';
        for (var n = 1; n <= 10; n++) {
          qtyOptions += '<option value="' + n + '"' + (n === item.quantity ? ' selected' : '') + '>' + n + '</option>';
        }
        dropdownsHtml += '<div class="tcf-item__select-row">' +
          '<label class="tcf-item__select-label">Quantity:</label>' +
          '<div class="tcf-item__select-wrap">' +
          '<select class="tcf-item__select js-tcfQty" data-key="' + item.key + '">' + qtyOptions + '</select>' +
          '<span class="tcf-item__select-chevron">&#8964;</span>' +
          '</div></div>';
      }

      return '<div class="tcf-item" data-key="' + item.key + '">' +
        '<img class="tcf-item__img" src="' + imgSrc + '" alt="' + item.product_title + '" loading="lazy" />' +
        '<div class="tcf-item__details">' +
          '<div class="tcf-item__top-row">' +
            '<span class="tcf-item__name">' + item.product_title + '</span>' +
            (giftLabel ? '' : '<button class="tcf-item__remove" data-key="' + item.key + '">Remove</button>') +
          '</div>' +
          '<div class="tcf-item__type">' + (giftLabel || item.product_type || '') + '</div>' +
          '<div class="tcf-item__price-row">' +
            '<span class="tcf-item__price">' + (giftLabel && item.final_price === 0 ? 'Free' : currency + ' ' + price) + '</span>' +
          '</div>' +
          dropdownsHtml +
        '</div>' +
        '</div>';
    }).join('');

    // Totals
    var subtotalVal  = cart.total_price / 100;
    var subtotalFmt  = subtotalVal.toFixed(2);
    var itemCount    = cart.item_count;
    var deliveryVal  = (typeof window.__tcfDeliveryRate !== 'undefined') ? window.__tcfDeliveryRate : null;
    var deliveryHtml = deliveryVal !== null
      ? '<div class="tcf-totals-row"><span>Delivery costs</span><span>' + currency + ' ' + deliveryVal.toFixed(2) + '</span></div>'
      : '<div class="tcf-totals-row"><span>Delivery costs</span><span class="tcf-totals-delivery-note">Calculated at checkout</span></div>';
    var itemTotalFmt = deliveryVal !== null ? (subtotalVal + deliveryVal).toFixed(2) : subtotalFmt;
    var vatLine      = cart.taxes_included ? '<p class="tcf-totals-vat">(Incl. VAT)</p>' : '';

    totalsEl.innerHTML =
      '<div class="tcf-totals-row"><span>Subtotal (' + itemCount + ' item' + (itemCount !== 1 ? 's' : '') + ')</span><span>' + currency + ' ' + subtotalFmt + '</span></div>' +
      deliveryHtml +
      '<p class="tcf-mytriumph">Become a <a href="/pages/mytriumph" class="tcf-mytriumph__link">MyTriumph</a> member and receive your deliveries for free!</p>' +
      '<div class="tcf-totals-row tcf-totals-row--total"><strong>Item Total</strong><strong>' + currency + ' ' + itemTotalFmt + '</strong></div>' +
      vatLine;
    // "Complete the set" — Shopify recommendations API
    var firstItem = sorted.find(function(i) { return !(i.properties && i.properties._gwp); });
    if (firstItem && firstItem.product_id) {
      fetch('/recommendations/products.json?product_id=' + firstItem.product_id + '&limit=4&intent=complementary')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var related = data.products || [];
          // Fallback to related intent if complementary returns nothing
          if (!related.length) {
            return fetch('/recommendations/products.json?product_id=' + firstItem.product_id + '&limit=4')
              .then(function(r) { return r.json(); })
              .then(function(d) { return d.products || []; });
          }
          return related;
        })
        .then(function(related) {
          if (!related.length) return;
          var html = '<div class="tcf-complete-set">' +
            '<div class="tcf-complete-set__header"><h3 class="tcf-complete-set__title">Complete the set</h3>' +
            '<button class="tcf-complete-set__prev js-tcfSetPrev" type="button">&#8249;</button></div>' +
            '<div class="tcf-complete-set__track js-tcfSetTrack">' +
            related.map(function(p) {
              var img = p.images && p.images[0] ? p.images[0].src.replace(/(\.(jpg|jpeg|png|gif|webp))/i, '_300x$1') : '';
              return '<a href="/products/' + p.handle + '" class="tcf-complete-set__item">' +
                '<img src="' + img + '" alt="' + p.title + '" loading="lazy" />' +
                '</a>';
            }).join('') +
            '</div></div>';
          var footer = flyout.querySelector('.triumph-cart-flyout__footer');
          footer.insertAdjacentHTML('beforeend', html);
          var track = flyout.querySelector('.js-tcfSetTrack');
          flyout.querySelector('.js-tcfSetPrev').addEventListener('click', function() {
            track.scrollBy({ left: -track.offsetWidth / 2, behavior: 'smooth' });
          });
        })
        .catch(function() {});
    }
    // Remove buttons
    itemsEl.querySelectorAll('.tcf-item__remove').forEach(function(btn) {
      btn.addEventListener('click', async function() {
        btn.textContent = '...';
        btn.disabled = true;
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.key, quantity: 0 }),
        });
        if (window.triumphGwpSync) await window.triumphGwpSync();
        var updated = await (await fetch('/cart.js')).json();
        updateCartBadge();
        openTriumphCartFlyout(updated, null);
      });
    });

    // Quantity selects
    itemsEl.querySelectorAll('.js-tcfQty').forEach(function(sel) {
      sel.addEventListener('change', async function() {
        var newQty = parseInt(sel.value, 10);
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: sel.dataset.key, quantity: newQty }),
        });
        if (window.triumphGwpSync) await window.triumphGwpSync();
        var updated = await (await fetch('/cart.js')).json();
        updateCartBadge();
        openTriumphCartFlyout(updated, null);
      });
    });

  }

  function showFeedback(msg, success) {
    feedbackEl.textContent = msg;
    feedbackEl.className = 'qb-feedback js-qbFeedback' + (success ? ' qb-feedback--success' : ' qb-feedback--error');
    feedbackEl.hidden = false;
    setTimeout(() => { feedbackEl.hidden = true; }, 4000);
  }

  function updateCartBadge() {
    return fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const count = cart.item_count;
        // Legacy selectors — exclude wishlist badge
        document.querySelectorAll('.js-cart-count, .icon__badge[data-count]:not(.js-wishlist-count)').forEach(el => {
          el.textContent = count;
          el.setAttribute('data-count', count);
          if (count > 0) el.classList.add('icon__badge--show');
        });
        // Triumph header badge
        document.querySelectorAll('.js-bubble-minicart').forEach(el => {
          el.textContent = count;
          el.classList.toggle('icon__badge--show', count > 0);
        });
        // Default theme cart-count-bubble
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(el => {
          el.textContent = count;
        });
        document.querySelectorAll('.cart-count-bubble .visually-hidden').forEach(el => {
          el.textContent = count + ' items';
        });
      });
  }

  // Expose globally so the wishlist page (and other scripts) can trigger a badge refresh
  window.triumphUpdateCartBadge = updateCartBadge;

  /* ─── trigger ─────────────────────────────────────────────── */

  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-quickbuy]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const handle = btn.dataset.quickbuy;
    if (!handle) return;

    // If clicked from inside the makeTheLook modal, hide it and store ref for back button
    const fromMakeTheLook = btn.closest('.js-makeTheLookModal');
    if (fromMakeTheLook) {
      sourceModal = fromMakeTheLook;
      fromMakeTheLook.classList.remove('show');
      fromMakeTheLook.style.display = '';
    } else {
      sourceModal = null;
    }

    // If this is a swatch click, preserve swatchContext so order stays fixed
    const isSwatchClick = btn.dataset.swatchClick === 'true';
    if (!isSwatchClick) swatchContext = null;

    // If clicked directly from a tile (not modal), rebuild data-related from tile swatches
    // so the modal always shows all colour siblings even when metafield is empty
    const parentTile = btn.closest('.js-productTile');
    if (parentTile && !isSwatchClick) {
      const activeDot = parentTile.querySelector('.productTile__colors .js-colorDot.colorDotSwatch--clicked[data-handle]');
      const allTileDots = parentTile.querySelectorAll('.productTile__colors .js-colorDot[data-handle]');
      const tileRelated = [];
      allTileDots.forEach(function(d) {
        if (d === activeDot) return;
        var dHandle = d.dataset.handle;
        if (!dHandle) return;
        var dUrl = d.getAttribute('href') || d.dataset.url || '/products/' + dHandle;
        var dImg = d.dataset.featuredImg || '';
        var dTitle = d.getAttribute('title') || dHandle;
        tileRelated.push({ url: dUrl, img: dImg, title: dTitle });
      });
      if (tileRelated.length) btn.dataset.related = JSON.stringify(tileRelated);
    }

    console.log('[QB] isSwatchClick:', isSwatchClick, '| swatchContext:', swatchContext ? swatchContext.map(s => s.handle) : null);

    // Show loading spinner on the bag icon
    const icon = btn.querySelector('.icon-shopping-bag');
    if (icon) icon.style.visibility = 'hidden';
    const spinner = document.createElement('span');
    spinner.className = 'qb-btn-spinner';
    btn.appendChild(spinner);
    btn.disabled = true;

    // Reset modal
    nameEl.textContent     = 'Loading…';
    subtitleEl.textContent = '';
    thumbsEl.innerHTML     = '';
    dotsEl.innerHTML       = '';
    swatchesEl.innerHTML   = '';
    simpleRow.innerHTML    = '';
    bandRow.innerHTML      = '';
    cupRow.innerHTML       = '';
    colorSec.hidden = true;
    sizeSec.hidden  = true;
    feedbackEl.hidden = true;
    atcBtn.disabled = true;
    atcBtn.classList.remove('qb-atc--oos');
    atcBtn.textContent = 'Add to Shopping Bag';

    // Show loader BEFORE modal opens
    showModalLoader();

    try {
      const res  = await fetch('/products/' + handle + '.js');
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const prod = await res.json();
      hideModalLoader();
      renderModal(prod);

      // Related product colour swatches — preserve order across swatch clicks
      try {
        const relatedRaw = btn.dataset.related;
        const relatedData = relatedRaw ? JSON.parse(relatedRaw) : [];

        if (!swatchContext && relatedData.length) {
          // First open: build ordered context — current product first, then related (deduplicated)
          const firstImgSrc = prod.variants[0] && prod.variants[0].featured_image && prod.variants[0].featured_image.src
            ? prod.variants[0].featured_image.src
            : (prod.images.length ? (typeof prod.images[0] === 'string' ? prod.images[0] : prod.images[0].src) : null);
          swatchContext = [{ handle: prod.handle, img: firstImgSrc, title: prod.title }];
          relatedData.forEach(function(r) {
            const h = r.url ? r.url.replace(/.*\/products\//, '').split('?')[0].split('#')[0] : '';
            // Skip if already in context (avoids duplicate when active product is also in related list)
            if (h && !swatchContext.find(function(s) { return s.handle === h; })) {
              swatchContext.push({ handle: h, img: r.img || null, title: r.title || '' });
            }
          });
        }

        if (swatchContext) {
          console.log('[QB] rendering swatchContext order:', swatchContext.map(s => s.handle), '| active:', prod.handle);
          swatchesEl.innerHTML = '';
          swatchContext.forEach(function(sw) {
            const isActive = sw.handle === prod.handle;
            const btn2 = document.createElement('button');
            btn2.type = 'button';
            btn2.className = 'qb-swatch' + (isActive ? ' qb-swatch--active' : '');
            btn2.title = sw.title;
            if (!isActive) {
              btn2.dataset.quickbuy = sw.handle;
              btn2.dataset.swatchClick = 'true';
            }
            const imgSrc = sw.img ? shopifyImgSize(sw.img, '120x120') : null;
            if (imgSrc) {
              btn2.innerHTML = '<img src="' + imgSrc + '" alt="' + sw.title + '" width="60" height="60" style="object-fit:cover;width:60px;height:60px;display:block;" />';
            } else {
              btn2.textContent = sw.title.charAt(0);
            }
            swatchesEl.appendChild(btn2);
          });
          colorSec.hidden = false;
        }
      } catch(e) {}

      openModal();
    } catch (err) {
      console.error('[QuickBuy] Failed to load product:', handle, err);
      hideModalLoader();
      nameEl.textContent = 'Could not load product. Check console for details.';
      openModal();
    } finally {
      // Remove spinner, restore icon
      spinner.remove();
      if (icon) icon.style.visibility = '';
      btn.disabled = false;
    }
  });

  // Expose globally for cart icon click handler
  window.openTriumphCartFlyout = openTriumphCartFlyout;

})();

/* ─── PLP tile: colour swatch → swap tile image ─────────────── */
(function () {
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.productTile__colors .js-colorDot[data-handle]');
    if (!dot) return;

    // Prevent navigation to the other product page
    e.preventDefault();
    e.stopPropagation();

    var tile = dot.closest('.js-productTile');
    if (!tile) return;

    var featuredImg    = dot.dataset.featuredImg;
    var featuredImg2x  = dot.dataset.featuredImg2x || featuredImg;
    var altText        = dot.getAttribute('title') || '';

    // Update active swatch state
    tile.querySelectorAll('.productTile__colors .js-colorDot').forEach(function (d) {
      d.classList.remove('colorDotSwatch--clicked', 'js-colorDotSwatch-clicked');
    });
    dot.classList.add('colorDotSwatch--clicked', 'js-colorDotSwatch-clicked');

    if (!featuredImg) return;

    // Swap every carousel slide's <img> to the clicked colour's image
    var carousel = tile.querySelector('.js-tileCarousel .js-imageCarousel');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('.js-imageItem');
    slides.forEach(function (slide, i) {
      var img = slide.querySelector('img');
      if (!img) return;

      // Build size variants by replacing the width/height numbers in Shopify CDN URL
      function resized(base, w, h) {
        return base.replace(/(_(\d+)x(\d+))/, '_' + w + 'x' + h);
      }

      // First slide shown immediately; others lazy
      img.src = featuredImg;
      img.srcset = featuredImg + ' 480w, ' + (featuredImg2x || featuredImg) + ' 960w';
      img.alt = altText;
      img.removeAttribute('data-src');
      img.classList.remove('js-lazy');

      // Also update <source> srcsets inside <picture>
      var picture = img.closest('picture');
      if (picture) {
        picture.querySelectorAll('source').forEach(function (src) {
          src.srcset = featuredImg + ' 1x, ' + (featuredImg2x || featuredImg) + ' 2x';
        });
      }
    });

    // Repoint the tile link to the clicked product's URL
    var tileLink = tile.querySelector('.js-productTileLink');
    var dotHref = dot.getAttribute('href') || dot.dataset.url;
    if (tileLink && dotHref) {
      tileLink.href = dotHref;
    }

    // Update the quick-buy button so the modal opens for the correct product
    var qbBtn = tile.querySelector('[data-quickbuy]');
    if (qbBtn && dot.dataset.handle) {
      qbBtn.dataset.quickbuy = dot.dataset.handle;

      // Rebuild data-related from all colour dots in this tile so the modal
      // always shows the full set of colour siblings regardless of metafield data
      var allDots = tile.querySelectorAll('.productTile__colors .js-colorDot[data-handle]');
      var siblings = [];
      allDots.forEach(function(d) {
        var dHandle = d.dataset.handle;
        if (!dHandle || dHandle === dot.dataset.handle) return; // skip active + dupes
        var dUrl = d.getAttribute('href') || d.dataset.url || '/products/' + dHandle;
        var dImg = d.dataset.featuredImg || '';
        var dTitle = d.getAttribute('title') || dHandle;
        siblings.push({ url: dUrl, img: dImg, title: dTitle });
      });
      qbBtn.dataset.related = JSON.stringify(siblings);
    }
  });
})();

/* ─── Product tile: carousel arrow handler ──────────────────── */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-carouselArrow');
    if (!btn) return;
    var nav = btn.closest('.js-carouselNavigation');
    if (!nav) return;
    var tile = nav.closest('.js-productTile');
    if (!tile) return;

    // Consume the event — stop navigation
    e.preventDefault();
    e.stopImmediatePropagation();

    var wrapper = tile.querySelector('.js-imageCarousel');
    if (!wrapper) return;

    var items = Array.prototype.slice.call(wrapper.querySelectorAll('.carousel__item'));
    if (!items.length) return;

    // Each item is full-width (carousel__item--full), so item width = wrapper width
    var itemWidth = wrapper.offsetWidth;
    if (!itemWidth) return;

    // Current index from scrollLeft — most reliable, avoids stale .active class
    var currentIndex = Math.round(wrapper.scrollLeft / itemWidth);
    currentIndex = Math.min(Math.max(currentIndex, 0), items.length - 1);

    var dir = btn.dataset.navigate === 'prev' ? -1 : 1;
    var targetIndex = Math.min(Math.max(currentIndex + dir, 0), items.length - 1);

    // Load lazy image at target before scrolling
    var targetItem = items[targetIndex];
    var lazyImg = targetItem.querySelector('.js-lazy[data-src]');
    if (lazyImg) {
      lazyImg.src = lazyImg.dataset.src;
      lazyImg.removeAttribute('loading');
      lazyImg.classList.remove('js-lazy');
    }

    // Scroll the wrapper to the exact target position
    wrapper.scroll({ left: targetIndex * itemWidth, behavior: 'smooth' });

    // Update active class
    items.forEach(function (item, i) {
      item.classList.toggle('active', i === targetIndex);
    });

    // Show/hide arrows based on position
    var prevBtn = nav.querySelector('.js-carouselArrow[data-navigate="prev"]');
    var nextBtn = nav.querySelector('.js-carouselArrow[data-navigate="next"]');
    var activeClass = 'carousel__arrow--active';
    if (prevBtn) prevBtn.classList.toggle(activeClass, targetIndex > 0);
    if (nextBtn) nextBtn.classList.toggle(activeClass, targetIndex < items.length - 1);

  }, true); // capture phase

})();

/* ─── Triumph Cart Flyout: close handlers ───────────────────── */
(function () {
  function closeFlyout() {
    var flyout = document.getElementById('triumphCartFlyout');
    if (!flyout) return;
    clearTimeout(flyout._autoCloseTimer);
    flyout.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-tcfClose')) closeFlyout();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeFlyout();
  });

  // Pause auto-close when mouse is over the flyout panel; resume when it leaves
  document.addEventListener('DOMContentLoaded', function () {
    var flyout = document.getElementById('triumphCartFlyout');
    if (!flyout) return;
    var panel = flyout.querySelector('.triumph-cart-flyout__panel');
    if (!panel) return;
    panel.addEventListener('mouseenter', function () {
      clearTimeout(flyout._autoCloseTimer);
    });
    panel.addEventListener('mouseleave', function () {
      // Resume 3s close timer when mouse leaves the panel
      clearTimeout(flyout._autoCloseTimer);
      flyout._autoCloseTimer = setTimeout(function () {
        flyout.classList.remove('is-open');
        document.body.style.overflow = '';
      }, 3000);
    });
  });

  // Measure header height and set CSS var so overlay+panel start below it
  function setHeaderHeight() {
    var header = document.querySelector('.js-header');
    if (!header) return;
    var h = header.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--tcf-header-h', Math.max(0, h) + 'px');
  }
  document.addEventListener('DOMContentLoaded', setHeaderHeight);
  window.addEventListener('resize', setHeaderHeight);
  // Also run immediately in case DOM is already ready
  setHeaderHeight();
})();

/* ─── Filter Panel Toggle (inline accordion) ────────────────── */
(function () {
  function getPanel() { return document.querySelector('.js-filterReplace'); }

  function openFilter() {
    var panel = getPanel();
    if (!panel) return;
    panel.classList.add('filterPanelContainer--show');
    var header = document.querySelector('.js-flexHeader');
    if (header) header.classList.add('filter-panel-open');
  }

  function closeFilter() {
    var panel = getPanel();
    if (!panel) return;
    panel.classList.remove('filterPanelContainer--show');
    var header = document.querySelector('.js-flexHeader');
    if (header) header.classList.remove('filter-panel-open');
  }

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-toggle="filter"]');
    if (toggleBtn) {
      e.preventDefault();
      var panel = getPanel();
      if (panel && panel.classList.contains('filterPanelContainer--show')) {
        closeFilter();
      } else {
        openFilter();
      }
      return;
    }
    if (e.target.closest('.js-filterClose')) {
      closeFilter();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeFilter();
  });
})();

